import React from "react";
import ReactDOM from "react-dom/client";
import {LoginPage} from "./LoginPage";

const rootElement = document.getElementById("trx-pos-login");

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
        <React.StrictMode>
            <LoginPage/>
        </React.StrictMode>
    );
}
